import useCustomUrl from '../hooks/useCustomUrl';
import useReferrerUrl from '../hooks/useReferrerUrl';
import usePageView from '../hooks/usePageView';
import useShopperContext from '../hooks/useShopperContext';
import useStorefrontInstanceContext from '../hooks/useStorefrontInstanceContext';
import useMagentoExtensionContext from '../hooks/useMagentoExtensionContext';
import useCart from '../hooks/useCart';
import mse from '@adobe/magento-storefront-events-sdk';
import msc from '@adobe/magento-storefront-event-collector';
export default function wrapUseApp(origUseApp) {
  if (!window.magentoStorefrontEvents) {
    window.magentoStorefrontEvents = mse;
  }
  msc;
  return function (props) {
    useShopperContext();
    useStorefrontInstanceContext();
    useMagentoExtensionContext();
    useCart();
    useCustomUrl();
    useReferrerUrl();
    usePageView();
    return origUseApp(props);
  };
}